import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'showErrorValue',
})
export class ShowErrorValuePipe implements PipeTransform {
  transform(obj: any): string {
    if (!obj || 'required' in obj) return '';
    return Object.values(obj).join('\n');
  }
}
